import React from 'react';
import PropTypes from 'prop-types';

import { AppointmentsScrollable } from '../../components/Agenda/Appointments';
import { useAppointment } from './Hooks';

const AppointmentsHistory = (props) => {

    const { medicalRecordNumber, card } = props;
    const [entries, query, entriesTotalSize, isEntriesLoading, getMore, handleFilterChange] = useAppointment(medicalRecordNumber);

    return (
        <AppointmentsScrollable
            card={card}
            data={entries}
            currentPage={query.pagination.page}
            totalSize={entriesTotalSize}
            isLoading={isEntriesLoading}
            getMore={getMore}
            onFilterChange={handleFilterChange} />
    );
}

export default AppointmentsHistory;

AppointmentsHistory.propTypes = {
    medicalRecordNumber: PropTypes.string.isRequired,
};